import { useState, useEffect } from "react";
import { loadIssueDetail } from "../services/issueIndentService";
import { loadPurchaseDetail } from "../services/purchaseIndentService";
import { loadVendorDetail } from "../services/vendorEnquiryService";
const useLoadVendorEnquiryDetailByVendor=()=> {
    const [VendorEnquiryDetails, setVendorEnquiryDetails] = useState([]);   

    // Fetch department data
    const fetchVendorDetail = async (selectedID = null,id_purchase=null) => {
        const para = { 
            p_companyid: localStorage.getItem("companyid"),
            p_plantid:1,
            p_id_enquiry:selectedID,
            p_id_purchase:id_purchase,
        };

        try {
            const data = await loadVendorDetail(para);
            if (data && data.length > 0) {
                setVendorEnquiryDetails(data);          

            }
            else {
                setVendorEnquiryDetails([]);              
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };   

    // Function to load department based on selected ID
    const loadVendorDetailByVendorID = async (selectedID ,id_purchase) => {
        await fetchVendorDetail(selectedID,id_purchase);
    };

    return {
        VendorEnquiryDetails,       
        loadVendorDetailByVendorID,
    };
};

export default useLoadVendorEnquiryDetailByVendor;
